
// Find all partner ad containers (any class that starts with PartnersAd)
const partnerAdContainers = jQuery('.PartnersAd__holder')

partnerAdContainers.each(function () {
    const adCards = jQuery(this).find('li')
    if (adCards.length !== 0) {

        const randomIndex = Math.floor(Math.random() * adCards.length)
        adCards.eq(randomIndex).show()
    }
})